(function () {
  if (window.__abaInit) return;
  window.__abaInit = true;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.aba-rv:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function scopeOf(root) { return root.closest('.shopify-section') || document; }
  function firstVid(root) { var i = scopeOf(root).querySelector('input[name="id"]'); return i ? i.value : ''; }

  function setQty(root, q) {
    var inp = scopeOf(root).querySelector('input[name="quantity"]');
    if (!inp) return;
    inp.value = q;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
    inp.dispatchEvent(new FocusEvent('blur'));
  }

  function setSecond(root, vid) {
    root.dataset.second = vid;
    var label = root.querySelector('[data-second-name]');
    root.querySelectorAll('.aba-dot2').forEach(function (d) {
      var on = d.getAttribute('data-vid') === String(vid);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && label) label.textContent = d.getAttribute('data-name');
    });
  }

  document.addEventListener('click', function (ev) {
    var bopt = ev.target.closest('.aba-bopt');
    if (bopt) {
      var root = bopt.closest('[data-aba-bundle]');
      if (!root) return;
      var q = bopt.getAttribute('data-q');
      root.dataset.q = q;
      root.querySelectorAll('.aba-bopt').forEach(function (x) { var on = x === bopt; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var panel = root.querySelector('.aba-second');
      if (panel) panel.hidden = q !== '2';
      if (q === '2' && !root.dataset.second) setSecond(root, firstVid(root));
      setQty(root, q);
      return;
    }
    var d2 = ev.target.closest('.aba-dot2');
    if (d2) {
      var r2 = d2.closest('[data-aba-bundle]');
      if (r2) setSecond(r2, d2.getAttribute('data-vid'));
      return;
    }
    var dot = ev.target.closest('.aba-dot');
    if (dot) {
      var scope2 = dot.closest('[data-aba-picker]');
      if (!scope2) return;
      scope2.querySelectorAll('.aba-dot').forEach(function (d) { d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
      var i = dot.getAttribute('data-i');
      scope2.querySelectorAll('.aba-stage img').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-i') === i); });
      var nm = scope2.querySelector('[data-aba-name]');
      if (nm) nm.textContent = dot.getAttribute('data-name');
      var pr = scope2.querySelector('[data-aba-price]');
      if (pr && dot.getAttribute('data-price')) pr.textContent = dot.getAttribute('data-price');
      scope2.querySelectorAll('[data-aba-cta]').forEach(function (a) { if (dot.getAttribute('data-href')) a.setAttribute('href', dot.getAttribute('data-href')); });
      return;
    }
    var chip = ev.target.closest('.aba-chip');
    if (chip) {
      var box = chip.closest('[data-aba-reviews]');
      if (!box) return;
      box.querySelectorAll('.aba-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var f = chip.getAttribute('data-f');
      box.querySelectorAll('.aba-rcard').forEach(function (card) {
        var show = f === 'all' ||
          (f === 'photo' && card.getAttribute('data-photo') === '1') ||
          (f === '5' && card.getAttribute('data-rating') === '5') ||
          (f.indexOf('c:') === 0 && card.getAttribute('data-color') === f.slice(2));
        card.hidden = !show;
      });
    }
  });

  /* side menu: one tap on a link goes straight to the page (some phones swallowed the first tap) */
  (function menuTap() {
    var sx = 0, sy = 0, moved = false;
    document.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; if (!t) return;
      sx = t.clientX; sy = t.clientY; moved = false;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      var t = e.touches[0]; if (!t) return;
      if (Math.abs(t.clientX - sx) > 8 || Math.abs(t.clientY - sy) > 8) moved = true;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (moved || !e.target.closest) return;
      var a = e.target.closest('header-drawer a[href]');
      if (!a) return;
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#' || a.target === '_blank') return;
      e.preventDefault();
      window.location.assign(a.href);
    }, { passive: false });
  })();

  /* two different colors: add the second hat first, then let the theme add the first one so the cart drawer opens and refreshes as usual */
  var resuming = false;
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[ref="addToCartButton"]');
    if (!btn || resuming) return;
    var root = document.querySelector('[data-aba-bundle]');
    if (!root || root.dataset.q !== '2') return;
    var f = firstVid(root), s = root.dataset.second;
    if (!f || !s || String(s) === String(f)) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    setQty(root, 1);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(s), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return;
      resuming = true;
      btn.click();
      resuming = false;
    });
  }, true);

  /* product page: smoother, faster color swap. The old photo is held on top and dissolves while the new one eases in */
  var swapping = false, swapTimer = null;
  var EASE = 'cubic-bezier(.22,.8,.24,1)';
  function swapPhoto() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var best = null, bestArea = 0;
    document.querySelectorAll('media-gallery .product-media img').forEach(function (im) {
      var r = im.getBoundingClientRect();
      var w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
      var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      var a = w > 0 && h > 0 ? w * h : 0;
      if (a > bestArea) { bestArea = a; best = im; }
    });
    if (!best || bestArea < 20000) return;
    document.querySelectorAll('.aba-swap-ov').forEach(function (o) { o.remove(); });
    var r = best.getBoundingClientRect();
    var cs = getComputedStyle(best);
    var o = document.createElement('img');
    o.className = 'aba-swap-ov';
    o.src = best.currentSrc || best.src;
    o.alt = '';
    o.setAttribute('aria-hidden', 'true');
    o.style.cssText = 'position:fixed;left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height +
      'px;object-fit:' + cs.objectFit + ';object-position:' + cs.objectPosition + ';border-radius:' + cs.borderRadius +
      ';z-index:60;pointer-events:none;opacity:1;will-change:opacity,transform;transform:none;transition:opacity .55s ' + EASE + ',transform .7s ' + EASE;
    document.body.appendChild(o);
    swapping = true;
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () { swapping = false; }, 1400);
    setTimeout(function () { o.style.opacity = '0'; o.style.transform = 'scale(1.025)'; }, 110);
    setTimeout(function () { o.remove(); }, 900);
  }
  document.addEventListener('change', function (ev) {
    if (ev.target.closest && ev.target.closest('variant-picker')) swapPhoto();
  }, true);
  function watchGallery() {
    var g = document.querySelector('media-gallery');
    if (!g || g.__abaWatch || !('MutationObserver' in window)) return;
    g.__abaWatch = true;
    new MutationObserver(function (muts) {
      if (!swapping) return;
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          var imgs = n.tagName === 'IMG' ? [n] : n.querySelectorAll('img');
          imgs.forEach(function (im) {
            if (im.animate) im.animate([{ opacity: 0, transform: 'scale(1.035)' }, { opacity: 1, transform: 'none' }], { duration: 560, easing: EASE });
          });
        });
      });
    }).observe(g, { childList: true, subtree: true });
  }

  /* cart drawer: on open, scroll just far enough that the checkout button sits at the bottom of the screen. The up arrow floats on the left, well above the discount code so it never covers the plus */
  (function cartScroll() {
    var wasOpen = false, btn = null;
    var st = document.createElement('style');
    st.textContent = '.aba-cart-up{position:absolute;left:14px;top:60%;z-index:6;width:46px;height:46px;border-radius:50%;border:0;background:#2B211C;color:#F5EFE4;display:grid;place-items:center;cursor:pointer;box-shadow:0 8px 22px #2b211c55;transition:transform .25s,opacity .25s}.aba-cart-up[hidden]{display:none}.aba-cart-up:hover{transform:translateY(-2px)}.aba-cart-up svg{width:22px;height:22px}';
    document.head.appendChild(st);
    function dlg() { return document.querySelector('#cart-drawer dialog'); }
    function content() { return document.querySelector('.cart-drawer__content'); }
    function ensureBtn(d) {
      if (btn && btn.isConnected) return btn;
      btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'aba-cart-up'; btn.hidden = true;
      btn.setAttribute('aria-label', 'לחזרה למעלה');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
      btn.addEventListener('click', function () { var c = content(); if (c) c.scrollTo({ top: 0, behavior: 'smooth' }); });
      d.appendChild(btn);
      return btn;
    }
    function toCheckout() {
      var c = content(), d = dlg(); if (!c || !d) return;
      var chk = d.querySelector('[name="checkout"]');
      if (!chk) return;
      var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var delta = chk.getBoundingClientRect().bottom - (vh - 26);
      if (delta > 0) c.scrollBy({ top: delta, behavior: 'smooth' });
    }
    function place(d, b) {
      var dr = d.getBoundingClientRect();
      var disc = d.querySelector('cart-discount-component') || d.querySelector('[class*="cart-discount"]');
      var top = disc ? disc.getBoundingClientRect().top - dr.top - 124 : dr.height - 360;
      top = Math.max(90, Math.min(top, dr.height - 260));
      b.style.top = top + 'px';
    }
    function sync() {
      var d = dlg(); if (!d) return;
      var b = ensureBtn(d);
      var open = d.open, c = content();
      if (open && !wasOpen) setTimeout(toCheckout, 500);
      wasOpen = open;
      if (!open || !c) { b.hidden = true; return; }
      b.hidden = c.scrollTop < 60 || (c.scrollHeight - c.clientHeight) < 80;
      if (!b.hidden) place(d, b);
    }
    setInterval(sync, 300);
    document.addEventListener('scroll', sync, true);
  })();

  function boot() { reveal(document); watchGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); watchGallery(); });
})();
